export default __webpack_public_path__ + "static/media/fine-art.845cbe72.svg";